import React from 'react';

const UniversityLocation = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "CollegeOrUniversity",
    "name": "Admas University",
    "image": "https://your-university-domain.com/logo.png", // Replace with actual logo URL
    "@id": "https://www.admasuniversity.edu.et", // Replace with actual URL
    "url": "https://www.admasuniversity.edu.et",
    "telephone": "+251-11-123-4567", // Replace with actual phone
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "123 University Ave",
      "addressLocality": "Addis Ababa",
      "addressRegion": "Addis Ababa",
      "postalCode": "1000",
      "addressCountry": "ET"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 9.004375791055955,
      "longitude": 38.763732072054275
    },
    "openingHours": "Mo-Fr 08:00-17:00",
    "sameAs": [
      "https://www.facebook.com/admasuniversity", // Optional social links
      "https://www.linkedin.com/school/admas-university/"
    ]
  };

  return (
    <div className="university-location">
      {/* JSON-LD structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />

      <p style={{ marginLeft: '50px' }}>
        Our campus is located at:
        <br />
        123 University Ave, Addis Ababa, Ethiopia
      </p>

      <div className="map-container" style={{ width: '100%', height: '450px' }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.649357418435!2d38.763732072054275!3d9.004375791055955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b85a3b294c027%3A0x5c059416ab392b2a!2zQWRtYXMgVW5pdmVyc2l0eSBIZWFkIE9mZmljZSB8IERlbWJlbCB8IOGKoOGLteGIm-GItSDhi6nhipLhiajhiK3hiLXhibIg4YuL4YqTIOGImC_hiaThibUgfCDhi7DhiJ3hiaDhiI0!5e0!3m2!1sen!2set!4v1744794076394!5m2!1sen!2set"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Admas University Meskel Campus Location"
        ></iframe>
      </div>
    </div>
  );
};

export default UniversityLocation;
